import { Component, inject } from '@angular/core';
import { ServiciosService } from '../services/servicios.service';
import { AccessService } from '../../core/services/access.service';
import { ServicioFormComponent } from "../servicio-form/servicio-form.component";

@Component({
  selector: 'app-servicio-create',
  standalone: true,
  imports: [ServicioFormComponent],
  templateUrl: './servicio-create.component.html',
  styleUrl: './servicio-create.component.css'
})
export class ServicioCreateComponent {
  private service = inject(ServiciosService)

  protected access = inject(AccessService).access

  constructor() {}

  ngOnInit(): void {
    this.service.title.update((value) => 'Nuevo Servicio')
  }
}
